/* eslint-disable no-unused-vars */
import { useContext, useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import DashboardHeader from "../common/DashboardHeader";
import Sidebar from "../common/Sidebar";
import DashBoard from "../Dashboard";
import useUserStore from "../../stores/useUserStores";

const AuthDashboard = (props: any) => {
  const { userdetail, setuserdetail, islogin, setislogin, isAdmin } =
    useUserStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!islogin) {
      navigate("/", {
        replace: true,
      });
    }
  }, []);
  const [side, setside] = useState(false);

  const handleside = () => {
    setside(!side);
  };
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 768) {
        setCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {islogin && !isAdmin ? (
        <div>
          <DashboardHeader side={side} handleside={handleside} />
          <div className="flex relative">
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
            {/* Backdrop for mobile */}
            {isMobile && !collapsed && (
              <div
                className="fixed inset-0 bg-black bg-opacity-50 z-10"
                onClick={() => setCollapsed(true)}
              />
            )}
            <div
              className={`flex-1 lg:p-4  p-1 transition-all duration-300 ease-in-out ${
                collapsed
                  ? isMobile
                    ? "ml-0"
                    : "ml-16"
                  : isMobile
                  ? "ml-0"
                  : "ml-56"
              }`}
            >
              <DashBoard side={side} handleside={handleside} />
            </div>
          </div>
        </div>
      ) : (
        <Navigate replace to="/" />
      )}
    </>
  );
};

export default AuthDashboard;
